import { render, staticRenderFns } from "./RequestDataForm.vue?vue&type=template&id=9b7a6136&"
import script from "./RequestDataForm.vue?vue&type=script&lang=js&"
export * from "./RequestDataForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports